<template>
   <div class="col-md-4" id="date_section">

      <info-box :title="'Program Block Start/End Date'" :centerContent="true" :height="366">


         <b-switch
            v-model="range"
            class="range-toggle"
            type="is-success"
         >Choose Date Range</b-switch>

         <!-- Start/End Date -->
         <v-date-picker
            v-if="range"
            mode='range'
            :is-inline="true"
            :show-caps="true"
            :show-popover="false"
            :pane-width='375'
            @input="$emit('changeDateRange', $event)"
            :theme-styles="themeStyles"
            :value="dateRange">
         </v-date-picker>

         <v-date-picker
            v-else
            mode="single"
            :is-inline="true"
            :show-caps="true"
            :show-popover="false"
            :pane-width='375'
            @input="$emit('changeDateRange', $event)"
            :theme-styles="themeStyles"
            :value="start">
         </v-date-picker>

         <!-- Recurrence -->
         <!-- <div class="input-container recurrence">
            <div class="block-box-label">Recurrence</div>
            <b-switch
               type="is-success"
               @input="$emit('changeRecurrence', $event)"
            >On</b-switch>
         </div> -->

      </info-box>
   </div>
</template>

<script>

export default {
   data() {
      return {
         range: false,
         themeStyles: {
            wrapper: {
               background: 'transparent',
               color: 'white'
            },
            weekdays: {
               color: '#7692ab'
            }
         }
      }
   },

   props: ['start', 'end'],

   mounted() {
      let startDT = this.start;
      let endDT = this.end;
      endDT.setHours(0);
      endDT.setMinutes(0);
      endDT.setSeconds(0);
      this.range = endDT.getTime() != startDT.getTime();
   },
   
   computed: {
      dateRange() {
         return {start: this.start, end: this.end};
      }
   },

   methods: {
      //if its a single date block, set range to be off
      isRange() {
         let startDT = this.start;
         let endDT = this.end;
         endDT.setHours(0);
         endDT.setMinutes(0);
         endDT.setSeconds(0);
         return endDT.getTime() != startDT.getTime();
      },
   },

   watch: {
      range() {
         if (!this.range) {
            this.$parent.$emit('changeDateRange', this.start);
         }
      }
   }

}
</script>

<style lang="scss" scoped>
#date_section {
   min-width: 446px;
}
.input-container.recurrence {
   margin-top: 50px;

   .block-box-label {
      margin-right: 14px;
   }

   .switch {
      font-size: 12px;
      margin: 0;
      display: inline-flex;
   }
}

.range-toggle {
   float: left;
   display: flex;
}
</style>
